import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs';
import { DatasetService } from './dataset.service';
import { DatasetActionContainerService } from './datasetACS';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class RecordService{

	public loadSubscription: Subscription;
	public record: BehaviorSubject<any>;
	public loading: BehaviorSubject<boolean>;
	public ready: BehaviorSubject<boolean>;
	public recordId: any;
	public extraParams: any;

	constructor(public datasetService: DatasetService, private datasetACS: DatasetActionContainerService){
		this.record = new BehaviorSubject(null);
		this.loading = new BehaviorSubject(false);
		this.ready = new BehaviorSubject(false);

		this.record.subscribe(response => {
			if(response && response.data && response.data.record && response.data.record.id){
				this.recordId = response.data.record.id;
			}
		});
	}

	setExtraParams(extraParams: any): void{
		this.extraParams = extraParams;
	}

	unsetParam(paramName: string): void{
		if (this.extraParams[paramName]){
			delete this.extraParams[paramName];
		}
	}

	reload(): Observable<any>{
		if(!this.recordId) return of(null);
		const result = new Subject();
		this.loading.next(true);
		let params = Object.assign({}, this.extraParams);
		if(typeof(this.datasetACS.datasetConfig.getCallParams) === 'function'){
			params = this.datasetACS.datasetConfig.getCallParams(params);
		}
		if(this.datasetACS && this.datasetACS.datasetConfig && this.datasetACS.datasetConfig.fetchConfig){
			if(this.datasetACS.datasetConfig.fetchConfig.with_attributes){
				params['with_attributes'] = this.datasetACS.datasetConfig.fetchConfig.with_attributes;
			}
			if(this.datasetACS.datasetConfig.fetchConfig.with_relations){
				params['with_relations'] = this.datasetACS.datasetConfig.fetchConfig.with_relations;
			}
		}
		if (this.loadSubscription && !this.loadSubscription.closed) this.loadSubscription.unsubscribe();
		this.loadSubscription = this.datasetService
		.get(this.datasetACS.datasetRoute + this.recordId, params)
		.subscribe({
			next: (response) => {
				this.record.next(response);
				result.next(response);
				this.loading.next(false);
				result.complete();
			},
			error: (errorResp) => {
				this.loading.next(false);
				result.complete();
				console.error('record.service.ts', errorResp);
			}
		});
		return result;
	}
}
